import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LivProvider } from './context/liv'; // Updated import for LivContext and LivProvider
import { AudioProvider } from './context/audio';

const clientId = process.env.GATSBY_GOOGLE_CLIENT_ID;

export const wrapRootElement = ({ element }) => {
  return (
    <LivProvider>
      <AudioProvider>
        <GoogleOAuthProvider clientId={clientId}>{element}</GoogleOAuthProvider>
      </AudioProvider>
    </LivProvider>
  );
};
